const HIMALAYAS = "HIMALAYAS_LIBRARY";
export const UPDATE_LIBRARY_MENU = `${HIMALAYAS}/update_library_menu`;
export const DELETE_LIBRARY = `${HIMALAYAS}/delete_library`;
export const SAVE_EDITED_LIBRARY = `${HIMALAYAS}/save-edited_library`;
export const OPEN_LIBRARY_FOLDER = `${HIMALAYAS}/open_library_folder`;
